import listItemMatch from '@/components/list-item-match/list-item-match.vue'

export default {
  components: {
    listItemMatch
  },
  props: {
    match: Object,
    team: Object,
    editMode: Boolean,
    hideDot: Boolean
  },
  computed: {
    matchTime () {
      return `${this.match.timeStart}, ${this.match.day === 2 ? 'Niedziela' : 'Sobota'}`
    }
  }
}
